import { render, staticRenderFns } from "./interface-manager.vue?vue&type=template&id=177b95e9&scoped=true"
import script from "./interface-manager.vue?vue&type=script&lang=js"
export * from "./interface-manager.vue?vue&type=script&lang=js"
import style0 from "./interface-manager.vue?vue&type=style&index=0&id=177b95e9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177b95e9",
  null
  
)

export default component.exports